import Vue from 'vue'

import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js/dist/vue-fullpage'
import VueI18n from 'vue-i18n'
import language from './language'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.use(VueI18n);
Vue.use(VueFullPage);

import App from './App.vue'

// 准备翻译的语言环境信息
const messages = language;
const i18n = new VueI18n({
    locale: 'zh', // 设置地区
    messages
});

Vue.config.productionTip = false

new Vue({
	i18n,
  render: h => h(App),
}).$mount('#app')
